angular
  .module('blacklistAdd')
  .component('blacklistAdd', {
    template: require('./blacklist-add.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService', 'Upload',
      function _($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService, Upload) {
        $rootScope.mainmenu = 'service';
        $rootScope.menu = 'blacklist';
        const API_URL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.blacklist = { TB_CITY_ID: -1, TB_AREA_ID: -1, NAME: '', POLYLINE: '', LEVEL: -1 };
        $resource(`${API_URL}/admin/meta/blacklist/add`).get().$promise
          .then((data) => {
            this.meta = data;
          })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.selectCity = () => {
          this.areas = this.meta.areas.filter(area => (parseInt(area.TB_CITY_ID, 10) === parseInt(this.blacklist.TB_CITY_ID, 10)));
          console.log(this.areas);
        };
        this.submit = () => {
          if (!this.blacklist.TB_CITY_ID || this.blacklist.TB_CITY_ID.length < 1) {
            alert($translate.instant('도시를 선택해주세요.'));
            return;
          }
          if (!this.blacklist.TB_AREA_ID || this.blacklist.TB_AREA_ID.length < 1) {
            alert($translate.instant('지역을 선택해주세요.'));
            return;
          }
          if (!this.blacklist.NAME || this.blacklist.NAME.length < 1) {
            alert($translate.instant('이름을 입력해주세요.'));
            return;
          }
          if (!this.blacklist.POLYLINE || this.blacklist.POLYLINE.length < 1) {
            alert($translate.instant('인코딩된 Polyline을 입력해주세요.'));
            return;
          }
          $resource(`${API_URL}/admin/maps/blacklist`).save(this.blacklist).$promise
            .then(() => {
              $location.path('blacklist');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/blacklist-add/blacklist-add.component.js